
const state = {
  userInfo: {}, /* 用户信息 */
  navList: [], /* 权限路由 */
  mainMenu: {}, /* head 主菜单 */
  webCinfo: {},
  hardware: ''/*服务器状态监控*/
}

export default state



// WEBPACK FOOTER //
// ./src/jvsit/vuex/state.js